import { useQueryClient, useMutation } from 'react-query'
import { type ExpertDomain } from '../../../../types/domain/expert-domain'
import { type NaturalPersonPersistence } from '../../../../types/persistence/natural-person-persistence'
import { api } from '../../../api'

const updateExpertNaturalData = async (
  id: number,
  data: NaturalPersonPersistence
): Promise<ExpertDomain> => {
  const response = await api.put<ExpertDomain>(`/experts/${id}/natural-data`, data)
  return response.data
}

export const useExpertNaturalDataMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn ({ id, data }: { id: number, data: NaturalPersonPersistence }) {
      return updateExpertNaturalData(id, data)
    },
    onSuccess (data) {
      queryClient.setQueryData(['expert', data.id], data)
    },
  })
}
